var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPad-Pro-Portrait",
    transform: "translate(-361.000000, -662.000000)",
    fillRule: "nonzero",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(382.500000, 683.500000) rotate(190.000000) translate(-382.500000, -683.500000) translate(352.000000, 653.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4055916,51.9055916 C18.5314695,51.9055916 8.90559159,42.2797137 8.90559159,30.4055916 C8.90559159,18.5314695 18.5314695,8.90559159 30.4055916,8.90559159 C42.2797137,8.90559159 51.9055916,18.5314695 51.9055916,30.4055916 C51.9055916,42.2797137 42.2797137,51.9055916 30.4055916,51.9055916 Z M30.4055916,49.9055916 C41.1751442,49.9055916 49.9055916,41.1751442 49.9055916,30.4055916 C49.9055916,19.636039 41.1751442,10.9055916 30.4055916,10.9055916 C19.636039,10.9055916 10.9055916,19.636039 10.9055916,30.4055916 C10.9055916,41.1751442 19.636039,49.9055916 30.4055916,49.9055916 Z",
    id: "Oval-3",
    opacity: 0.4,
    transform: "translate(30.405592, 30.405592) rotate(-315.000000) translate(-30.405592, -30.405592) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3359124,33.9809704 C16.3321195,33.8147628 16.3302128,33.6480893 16.3302128,33.4809704 C16.3302128,21.6068483 25.9560907,11.9809704 37.8302128,11.9809704 C49.7043349,11.9809704 59.3302128,21.6068483 59.3302128,33.4809704 C59.3302128,33.6480893 59.3283061,33.8147628 59.3245132,33.9809704 L57.3239274,33.9809704 C57.3281093,33.8148117 57.3302128,33.6481367 57.3302128,33.4809704 C57.3302128,22.7114178 48.5997654,13.9809704 37.8302128,13.9809704 C27.0606602,13.9809704 18.3302128,22.7114178 18.3302128,33.4809704 C18.3302128,33.6481367 18.3323163,33.8148117 18.3364982,33.9809704 L16.3359124,33.9809704 Z",
    id: "Oval-3",
    transform: "translate(37.830213, 22.980970) rotate(-315.000000) translate(-37.830213, -22.980970) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.6ccd2781eced2938768205857a5a154d.svg";
export { ForwardRef as ReactComponent };